import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/_root';
import './index.css';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

reportWebVitals();
